import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
export const getServicesByStatuses = (year, employeeId, departmentId, serviceId, includeInactive = false) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.put(
                `${FIRMFLOWURL}api/Analytics/ServiceStatusReport`,
                {
                    year: year,
                    employeeId: employeeId,
                    departmentId: departmentId,
                    serviceId: serviceId,
                },
                {
                    headers: { Authorization: token },
                    params: { includeInactive: Boolean(includeInactive) },
                }
            );
            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.message });
        }
    });
};
